



import Vue from 'vue';
import { mapState } from 'vuex';
import Helpers from '../mixins/helpers';
export default Vue.extend({
	name: 'RateDisclaimer', 
	computed: {
		...mapState({
			finance(): any { return this.$store.state.finance },
			tpr(): any { return this.$store.state.tpr },
			app(): any { return this.$store.state.app }
		}), 
		dateFrom(): string {
			return Helpers.formattedDate(new Date());
		},
		dateTo(): string {
			return Helpers.formattedDateMinusOneDay(this.tpr.validityDate);
		},
		copy(): string {
			if (this.flow == 'business' && this.app.step > 1){
				return this.businessCopy;
			}
			else if (this.flow == 'get-tpr' && this.app.step != 0){ 
				return this.indicativeOfferCopy;
			}
			else if (this.flow == 'adjust-tpr'){
				return this.tprOfferCopy;
			}
			// sliders are shown and it's for finance campaign or business finance campaign
			return ''; 
		},
		flow(): string {
			return this.$store.getters.flow;
		},
		businessCopy(): string {
			return `Annual percentage rates range <strong>from ${this.finance.cmpFrom}% to ${this.finance.cmpTo}% <sup>[^]</sup></strong>. At least half of business applicants will get the advertised rate or lower. We may offer you a lower or higher rate depending on your credit score and other criteria.`;
		},
		indicativeOfferCopy(): string {
			return `<p>Comparison rates range <strong>from ${this.finance.cmpFrom}% to ${this.finance.cmpTo}% <sup>[^]</sup></strong>. At least half of consumers will get the advertised rate or lower. We may offer you a lower or higher rate depending on your credit score and other&nbsp;criteria.</p>`;
		},
		tprOfferCopy(): string {
			const d = `<p><strong>We'll hold this interest rate for you until the ${this.dateTo}</strong></p>`;
			const t = `<p>Your Toyota Personalised Repayment and interest rate are based on the information you provided in the form and the selected vehicle details. It is current as of the <strong>${this.dateFrom}</strong> and is subject to change. After the <strong>${this.dateTo}</strong>, you will need to refill the form to receive new Toyota Personalised&nbsp;Repayments.</p>`;
			return this.app.step == 2 || this.app.step == 0 ? d + t : t;
		},
	}
});
